import * as actionTypes from '../action-types'
import { getStoresFromAgreement } from '../../common/utils'
import * as _ from 'lodash'

const initialState = {
  newAgreement: {
    agreementValidity: 'VALID',
    authCodeLm: 'authCodeLm',
    userName: 'string',
    userType: 'PRODUCT_MANAGER',
    agreementState: 'DRAFT',
    transportCosts: 'SUPPLIER',
    agreementPurpose: 'RETURN',
    type: 'SAME_SUPPLIER',
    agreementDetails: [],
    agreementStores: []
  },
  selectedAgreement: {},
  selectedRefs: [],
  agreementsList: [],
  agreementTableSort: {}
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.UPDATE_NEW_AGREEMENT:
      return {
        ...state,
        newAgreement: {
          ...state.newAgreement,
          ...payload
        }
      }
    case actionTypes.RESET_NEW_AGREEMENT:
      return {
        ...state,
        newAgreement: initialState.newAgreement
      }
    case actionTypes.UPDATE_SELECTED_AGREEMENT:
      if (_.has(payload, 'proposals')) {
        for (let [index, proposal] of payload.proposals.entries()) {
          for(let [j, connection] of proposal.connections.entries()) {
            const product = payload.agreementDetails.find(item => connection.id.agreementDetailId === item.agreementDetailId);
            if(product) {
              payload.proposals[index].connections[j].description = product.description
              payload.proposals[index].connections[j].eanCode = product.eanCode
              payload.proposals[index].connections[j].refLm = product.refLm
              payload.proposals[index].connections[j].acceptedPrice = product.acceptedPrice
              payload.proposals[index].connections[j].gamma = product.gamma
            }

          }
        }
      }

      if (_.has(payload, 'agreementDetails')) {
        payload.agreementStores = getStoresFromAgreement(payload)
      }
      const selectedAgreement = Object.assign({}, state.selectedAgreement, payload)
      return {
        ...state,
        selectedAgreement: {
          ...selectedAgreement,
          ...payload
        }
      }
    case actionTypes.RESET_SELECTED_AGREEMENT:
      return {
        ...state,
        selectedAgreement: initialState.selectedAgreement
      }
    case actionTypes.UPDATE_SELECTED_REFS:
      return {
        ...state,
        selectedRefs: payload
      }
    case actionTypes.RESET_SELECTED_REFS:
      return {
        ...state,
        selectedRefs: initialState.selectedRefs
      }
    case actionTypes.UPDATE_AGREEMENTS_LIST:
      return {
        ...state,
        agreementsList: payload
      }
    case actionTypes.UPDATE_AGREEMENT_TABLE_SORT:
      return {
        ...state,
        agreementTableSort: payload
      }
    case actionTypes.UPDATE_AGREEMENT_PURPOSES:
      return {
        ...state,
        selectedAgreement: payload
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/redux-store/reducers/agreement-reducer.js